import React from "react";
import { useLocation } from "react-router-dom";

const PageTransition = ({ children }) => {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition page-in">
      {children}
    </div>
  );
};

export default PageTransition;
